<template>
    <section class="layout">
        <ds-modal
            :is-open="isCompanyModalOpen"
            class="regular-modal"
            show-close
            title="Add New Company"
            data-qa="Add new company"
            @close="isCompanyModalOpen = false"
        >
            <div class="layout">
                <div>
                    <ds-input-field
                        v-model="companyCreateRequest.companyName"
                        class="input-border"
                        label="Company"
                        name="Company"
                        data-qa="company-name"
                        required
                    />
                </div>
            </div>
            <div>
                <ds-button
                    data-qa="company-name"
                    :disabled="disableSave"
                    :loading="saving"
                    @click="updateContactInfo"
                >
                    Add Company
                </ds-button>

                <ds-filled-button data-qa="cancel-button" @click="modalClose">
                    Cancel
                </ds-filled-button>
            </div>
        </ds-modal>
    </section>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            saving: false,
            companyCreateRequest: {
                companyName: '',
            },
            isCompanyModalOpen: false,
        };
    },

    computed: {
        disableSave() {
            return !this.companyCreateRequest.companyName;
        },
    },

    methods: {
        showModal() {
            this.isCompanyModalOpen = true;
        },

        async updateContactInfo() {
            const url = '/app/contact/addCompany';

            this.saving = true;

            try {
                const response = await axios.post(url, this.companyCreateRequest);

                this.$root.$emit('COMPANY_DETAILS', response.data);
                this.modalClose();
            } catch (error) {
                this.$error({ message: 'Unable to save company' });
            }
        },

        modalClose() {
            this.modalReset();
            this.isCompanyModalOpen = false;
        },

        modalReset() {
            this.companyCreateRequest.companyName = '';
            this.saving = false;
        },
    },
};
</script>

<style scoped lang="scss">
button {
    white-space: nowrap;
    margin: $spacing-100;
}
</style>
